// assets
import hwStatsLogo from '../../../assets/common/HW_stats 1.png';

// code imports
import { Link } from 'react-router-dom';
import HeaderMenu from './HeaderMenu';

function Desktop_Header({ style, links, isSticky, onLogout, page, ...otherProps }) {
  const HEADER_H = page === 'hitstats' ? 92 : 68;

  const styles = {
    background: isSticky ? 'rgba(26, 6, 47, 0.72)' : 'transparent',
    backdropFilter: isSticky ? 'blur(16px) saturate(140%)' : 'blur(10px)',
    WebkitBackdropFilter: isSticky ? 'blur(16px) saturate(140%)' : 'blur(10px)',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    boxShadow: isSticky ? '0 8px 30px rgba(0,0,0,0.35)' : undefined,
    transition: 'background 0.3s ease, box-shadow 0.3s ease',
    height: `${HEADER_H}px`,
    position: isSticky ? 'sticky' : 'relative',
    top: isSticky ? 0 : undefined,
    zIndex: 1000,
    ...style,
  };

  const logoSrc = page === 'hitstats' ? hwStatsLogo : "https://cdn.octathorpeweb.com/v1/webstore/hitwicket-logo.png";
  const homeHref = page === 'hitstats' ? '/hitstats' : '/';

  return (
    <div {...otherProps} className="Header d-flex align-items-center px-4" style={styles}>
      {/* Logo */}
      <div className="d-flex align-items-center" style={{ width: 170 }}>
        <Link to={homeHref} style={{ display: 'inline-flex', alignItems: 'center' }}>
          <img
            src={logoSrc}
            alt="Hitwicket"
            style={{
              height: page === 'hitstats' ? 52 : 52,
              width: 'auto',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Link>
      </div>

      {/* Menu */}
      <div className="flex-grow-1 d-flex justify-content-end align-items-center">
        <HeaderMenu links={links} device="desktop" onMenuItemClick={onLogout} />
      </div>
    </div>
  );
}

export default Desktop_Header;
